import _ from "lodash";
import React, { useState } from "react";
import {
  BarChart,
  ResponsiveContainer,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  Cell,
  Customized,
} from "recharts";
import { colors } from "@toddle-edu/ds-theme";
import PropTypes from "prop-types";
import ConditionalWrapper from "Utils/ConditionalWrapper";

const tooltipCursorProps = {
  opacity: 0.1,
};

const BarChartCustomizable = props => {
  const {
    data,
    legendComp,
    containerStyle,
    barProps,
    yAxisProps,
    xAxisProps,
    legendStyle,
    barChartStyle,
    showLegend,
    showXAxis,
    showYAxis,
    showTooltip,
    tooltipContent,
    showLabel,
    labelProps,
    isResponsive,
    responsiveContainerProps,
    toolTipWrapperStyle,
    cartisianGridProps = {
      vertical: false,
      stroke: colors.neutral700,
      fill: "transparent",
    },
    customHandleMouseOver,
    customHandleMouseLeave,
    customizedComponent,
  } = props;

  const [focusBar, setFocusBar] = useState(null);

  const handleMouseOver = state => {
    if (state.isTooltipActive) {
      setFocusBar(state.activeTooltipIndex);
    } else {
      setFocusBar(null);
    }
  };

  const handleMouseLeave = () => {
    setFocusBar(null);
  };

  return (
    <div style={containerStyle}>
      <ConditionalWrapper
        type={"wrapperAsElement"}
        wrapper={<ResponsiveContainer {...responsiveContainerProps} />}
        condition={isResponsive}
      >
        <BarChart
          {...barChartStyle}
          data={data}
          onMouseMove={
            _.isFunction(customHandleMouseOver)
              ? customHandleMouseOver
              : handleMouseOver
          }
          onMouseLeave={
            _.isFunction(customHandleMouseLeave)
              ? customHandleMouseLeave
              : handleMouseLeave
          }
          accessibilityLayer
        >
          {showLegend && <Legend {...legendStyle} content={legendComp} />}
          <CartesianGrid {...cartisianGridProps} />
          <XAxis hide={!showXAxis} {...xAxisProps} />
          <YAxis hide={!showYAxis} {...yAxisProps} />
          {showTooltip && (
            <Tooltip
              wrapperStyle={toolTipWrapperStyle}
              content={tooltipContent}
              cursor={tooltipCursorProps}
            />
          )}
          <Bar {...barProps}>
            {showLabel && <LabelList {...labelProps} />}
            {_.map(data, (entry, index) => (
              <Cell
                key={entry?.id}
                fill={
                  focusBar === index
                    ? _.get(props, "focusColor", entry.fill)
                    : entry.fill
                }
              />
            ))}
          </Bar>

          {customizedComponent ? (
            <Customized component={customizedComponent} />
          ) : null}
        </BarChart>
      </ConditionalWrapper>
    </div>
  );
};

BarChartCustomizable.defaultProps = {
  data: [],
  showLegend: true,
  showXAxis: false,
  showYAxis: true,
  showTooltip: false,
  showLablel: false,
  labelProps: {},
  containerStyle: {},
  yAxisProps: {},
  xAxisProps: {},
  barChartStyle: {},
  barProps: {},
  legendStyle: {},
  isResponsive: false,
  responsiveContainerProps: {},
  toolTipWrapperStyle: {},
};

BarChartCustomizable.propTypes = {
  data: PropTypes.array,
  showLegend: PropTypes.bool,
  showXAxis: PropTypes.bool,
  showYAxis: PropTypes.bool,
  showTooltip: PropTypes.bool,
  showLablel: PropTypes.bool,
  labelProps: PropTypes.object,
  containerStyle: PropTypes.object,
  yAxisProps: PropTypes.object,
  xAxisProps: PropTypes.object,
  barChartStyle: PropTypes.object,
  barProps: PropTypes.object,
  legendStyle: PropTypes.object,
  isResponsive: PropTypes.bool,
  responsiveContainerProps: PropTypes.object,
  toolTipWrapperStyle: PropTypes.object,
};

export default BarChartCustomizable;
